import React from 'react';
import { useParams } from 'react-router-dom';
import CampaignEditor from '@/components/campaigns/CampaignEditor';

/**
 * Campaign editor, edit mode (quantix-api/docs/campaigns/TASKS.md, task W3):
 * source -> fields -> mapping -> defaults -> review, all five steps editable.
 * The active step is driven by the `?step=` query param.
 */
const CampaignEditPage: React.FC = () => {
    const { campaignId } = useParams<{ campaignId: string }>();

    return <CampaignEditor mode="edit" campaignId={campaignId} />;
};

export default CampaignEditPage;
